module.exports = __webpack_public_path__ + "img/sirPos.9429d7bf.png";